<template>
<d-action-dialog
  v-bind:value="value"
  v-on:input="$emit('input', $event)"
  :onSave="onSave"
  :onClose="onClose"
  :validate="validate"
>
  <template slot="title">
    Lizenz zuweisen
  </template>
  <template>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row v-if="item">
        <v-col cols="6">
          <d-combobox
            label="Name"
            v-model="item.id"
            :items="users"
            item-text="name"
            item-value="id"
          />
        </v-col>
        <v-col cols="6">
          <d-combobox
            label="Lizenz"
            v-model="item.licenseType"
            :items="licenseTypes"
          />
        </v-col>
      </v-row>
    </v-form>
  </template>
</d-action-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { validation } from '../../helpers'
import { genericService } from '../../services'

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    item: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null,
          licenseType: null
        }
      }
    }
  },
  data() {
    return {
      validation: validation,
      valid: true,

      defaultItem: {
        id: null,
        licenseType: null
      },

      licenseTypes: [],
    }
  },
  methods: {
    ...mapActions('users', ['associateAssistLicense']),
    validate() {
      this.valid = this.$refs.form.validate();
      return this.valid;
    },
    onSave() {
      // when a user edits the lastname and, without blurring the field, directly
      // clicks the save button, search and validation will not happen before getting here
      // this will lead to not updating the associated combo model with the user data
      // lucky for us this.lastnameACSearch will contain the value, as it would have been
      // used for looking up existing user with this lastname
      if (this.valid) {
        this.associateAssistLicense({
          id: this.item.id.id,
          licenseType: this.item.licenseType.value
        })
      }
      // afterwards onClose gets called automatically
    },
    onClose () {
      // is called after onSave automatically
      this.item = {...this.defaultItem};
    },
  },
  computed: {
    ...mapState({
      drkusers: state => state.users.drk,
      assistusers: state => state.users.assist
    }),
    ...mapGetters({
      fullRec: 'organisation/fullRec',
    }),
    users() {
      const ids = this.assistusers.map(item => item.id);
      return this.drkusers.filter(user => user.active && ids.indexOf(user.id) === -1)
    },
  },
  watch: {
    value (val) {
      // on being shown (v-model = true as set in parent component)
      if (val) {
        // reload list of available licenses
        genericService.get(`organisations/assistLicenses/${this.fullRec.id.value}.json`)
          .then(data => {
            this.licenseTypes = data
          })
      }
    }
  }
}
</script>
